import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

export const crearOEditarTurno = async (turno) => {
    const configs = { headers: getHeaders() };

    try {
        if (turno.id != "") {
            const resp = await axios.put(
                `${API_URL}/turnos/${turno.id}`,
                turno,
                configs
            );
            return resp.data;
        }

        const resp = await axios.post(`${API_URL}/turnos`, turno, configs);
        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const inactivarTurno = async (id_turno) => {
    try {
        const resp = await axios.delete(`${API_URL}/turnos/${id_turno}`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const selectTurnosSedes = async () => {
    try {
        const response = await axios.get(`${API_URL}/turnos/selectTurnoSede`, {
            headers: getHeaders(),
        });

        return response.data;
    } catch (error) {
        return processError(error);
    }
};

export const asignarTurnoEmpleado = async (data) => {
    try {
        const resp = await axios.post(
            `${API_URL}/cuadroTurnos/nuevoCuadroTurno`,
            data,
            {
                headers: getHeaders(),
            }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const editarCuadroTurnoActual = async (data) => {
    try {
        const resp = await axios.post(
            `${API_URL}/cuadroTurnos/editarCuadroTurnoActual`,
            data,
            {
                headers: getHeaders(),
            }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const obtenerConvenciones = async () => {
    try {
        const resp = await axios.get(`${API_URL}/cuadroTurnos/convenciones`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const verTurno = async (id) => {
    try {
        const resp = await axios.get(`${API_URL}/turnos/${id}`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};


